import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { BrowserModule } from '@angular/platform-browser';
import { MyApp } from './app.component';
import { BackgroundMode } from '@ionic-native/background-mode';

import { AndroidPermissions,AndroidPermissionsOriginal } from '@ionic-native/android-permissions';
import { Geolocation } from '@ionic-native/geolocation';


import { HeaderColor } from '@ionic-native/header-color';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import {datos} from '../providers/datos';

import { servicios_ocre } from '../pages/servicios_ocre/servicios_ocre';
import { about } from '../pages/about/about';
import { contactos } from '../pages/contactos/contactos';
import { lista } from '../pages/lista/lista';
import { Modal } from '../pages/modal/modal';
import { html } from '../pages/html/html';

import { tarjetas } from '../pages/tarjetas/tarjetas';
import { direcciones } from '../pages/direcciones/direcciones';
import { SMS } from '@ionic-native/sms';
 


import { mis_servicios } from '../pages/mis_servicios/mis_servicios';

import { Detalle } from '../pages/detalle/detalle';

import { Login } from '../pages/login/login';

import { Facebook } from '@ionic-native/facebook';

import { LocalNotifications } from '@ionic-native/local-notifications';


import { promociones } from '../pages/promociones/promociones';
import { pago } from '../pages/pago/pago';
import { notificaciones } from '../pages/notificaciones/notificaciones';
import { NativeStorage } from '@ionic-native/native-storage';





@NgModule({
  declarations: [
    MyApp,
    servicios_ocre,
    about,
    promociones,
    pago,
    notificaciones,
    contactos,
    lista,
    Modal,
    Detalle,
    Login,
    mis_servicios,
    tarjetas,
    direcciones,
    html

  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    servicios_ocre,
    about,
    promociones,
    pago,
    notificaciones,
    contactos,
    lista,
    Modal,
    Detalle,
    html,
    Login,
    mis_servicios,
    tarjetas,
    direcciones

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
  
    datos,
    BackgroundMode,
    Geolocation,
    Facebook,
    LocalNotifications,
    HeaderColor,
    StatusBar, SplashScreen,NativeStorage,
    
    
    { provide: ErrorHandler, useClass: IonicErrorHandler }]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts